import React from 'react'
import { Layout } from '../widgets'
import { AppStoreBanner } from '../components'
import { termsOfService } from '../shared'

const Line = (props) => <div className='submission-tips-body'>{props.children}</div>

const SubmitTopTrack = () => (
  <div className='body-container submission-tips'>
    <Layout>
      <Layout.Header>
        Great news, you no longer need our approval!
      </Layout.Header>
      <div className='layout-content'>
        <Line>
          We’ve made it even easier to post and share your Voloco tracks.
        </Line>
        <Line>
          Instead of submitting a track, you can now post it right in the app!
          Posting a track in the app makes it available to everyone using Voloco.
        </Line>
        <Line>
          Any track you post in Voloco has a chance to be featured, and if we
          feature your track, millions of Voloco users will hear it!
          And even if your track isn’t featured, you can always share a link to it with anyone.
        </Line>
        <Line>
          Posting is easy. Create a track as usual. After recording, on the Review
          screen, just tap the "Publish" button to share to your Voloco Creator Profile.
        </Line>
        <Line>
          Don’t have the app yet? Download with the links below!
        </Line>
        <Line>
          Please remember that all content posted on Voloco must comply with the {termsOfService()} in order to remain on the platform.
        </Line>
        <Line>
          Questions, Feedback? Message our support team at support@resonantcavity.com
        </Line>
        <div className='float-left margin-vertical-small'>
          <AppStoreBanner title={false} />
        </div>
      </div>
    </Layout>
  </div>
)

export default SubmitTopTrack
